import React, { Component }  from 'react';
import Card from '@material-ui/core/Card';
//import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ClientLogo from '../utils/ClientLogo';
 
import CardContent from '@material-ui/core/CardContent';

import { List,  Datagrid, TextField,  DateField, ReferenceField } from 'react-admin';
import LinkToDocument from './components/LinkToDocument.js';

import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import ThumbUpIcon from '@material-ui/icons/ThumbsUpDown';
import Tooltip from '@material-ui/core/Tooltip';

//import {   useRedirect } from 'react-admin';

let logo ;
        logo = <ClientLogo   />;
 
 
if (localStorage.getItem("user") === null )
{
    localStorage.setItem("user",  JSON.stringify( {"status":"Active" , 
                                                    "avatar":"photo_0.png",
                                                    "type" : "" }  ) );
}


 

 let fakeProps = {
        basePath: "/dashboard",
        hasCreate: false,
        hasEdit: false,
        hasList: true,
        hasShow: false,
        history: {},
        location: { pathname: "/", search: "", hash: "", state: undefined },
        match: { path: "/", url: "/", isExact: true, params: {} },
        options: {},
        permissions: null,
        resource: "dashboard"
    }

   let fakePropsPending = {
        basePath: "/pending",
        hasCreate: false,
        hasEdit: false,
        hasList: true,
        hasShow: false,
        history: {},
        location: { pathname: "/", search: "", hash: "", state: undefined },
        match: { path: "/", url: "/", isExact: true, params: {} },
        options: {},
        permissions: null,
        resource: "pending"
    }
 
var isAdmin =  JSON.parse(localStorage.getItem("user")).type === "admin"   ;

 console.log( isAdmin );

var filter = null;
if ( !isAdmin ){
  filter = { client:  JSON.parse(localStorage.getItem("user")).client };
}


const DashboardTitle = ({ record }) => {
    return <span>  </span>;
};
///
const EditApprovedButton = ({ record }) => 
     record && isAdmin ? (<Tooltip title="Review document"><Button component={Link} to={{pathname: '/documents/' + record.id , }} > <ThumbUpIcon /> </Button></Tooltip>) : null;
///


/*
<ReferenceField source="type" reference="document_types" label="Document type" linkType={false}>
                                                <TextField source="description" />
                                            </ReferenceField>

 <ReferenceField source="type" reference="document_types" label="Document type" linkType={false}>
                                                <TextField source="description" />
                                            </ReferenceField>

                                            */

const ParaAdmin = (record) =>  <CardContent>
                                       <center>
                                      {logo}
                                <CardHeader title={ "Approved documents expired on the last 7 days" }  /> 
                                      <List {...fakeProps} exporter={false} perPage={10000} pagination={null}  
                                        bulkActionButtons={false} actions={null} title={<DashboardTitle />}
                                          filter={filter}  >
                                           <Datagrid   >
                                            <ReferenceField source="client" reference="clients" linkType={false} >
                                                <TextField source="name" />
                                            </ReferenceField>
                                            
                                            <TextField source="description" />
                                             <ReferenceField source="folder" reference="folders2" linkType={false} >
                                              <TextField source="FullName" />
                                          </ReferenceField>
                                            <DateField source="created_at" />
                                            <LinkToDocument label="Download"/>
                                            <DateField source="expirationdate" label="Expiration" />
                                           </Datagrid>
                                         </List> 
                              <CardHeader title={ "Documents pending to review" }  /> 
                                      <List {...fakePropsPending} exporter={false} perPage={10000} pagination={null}  
                                        bulkActionButtons={false} actions={null} title={<DashboardTitle />}
                                          filter={filter}  >
                                           <Datagrid   >
                                           <EditApprovedButton />
                                            <ReferenceField source="client" reference="clients" linkType={false} >
                                                <TextField source="name" />
                                            </ReferenceField>
                                           
                                            <TextField source="description" />
                                            <ReferenceField source="folder" reference="folders2" linkType={false} >
                                                <TextField source="FullName" />
                                            </ReferenceField>
                                            <DateField source="created_at" />
                                            <LinkToDocument label="Download"/>
                                            </Datagrid>
                                         </List> 

                                         </center>   
                                     </CardContent> ;
 

  ///

/*
export default () =>
(
 <React.Fragment>
    <Card >
      <ParaOwner> </ParaOwner>
      <ParaOtros> </ParaOtros>
    </Card>
  </React.Fragment>
  );
*/

//const redirect = useRedirect();

class dashboard extends Component {
    state = {};
    componentWillMount() {
      if ( !localStorage.getItem("dbloades"))  {
        localStorage.setItem('dbloades', true);
        window.location.reload(true);
      }
    }
    componentDidMount() {
      if ( !isAdmin) {
        window.location.href = "#/folders" ;      
      }
    }
    render() {
return (

      <React.Fragment>
        <Card >
          <ParaAdmin> </ParaAdmin>
          
        </Card>
      </React.Fragment>

  )}}

export default (dashboard);

 ///
 